define(function(require) {
    // RESEAU_COLLEGIAL themeset definition config
    var DomUtil = require("cartovista").DomUtil;
    return  {
        ID : "FREQUENTATION_ALL",
        TYPE : "ThemeSetGroup",
        TITLE : "Par lieux de fréquentation de l'élève",
        THEMESETS_ELEMENTS : [
            {
                ID : "FREQUENTATION_FRA_STA",
                TYPE : "ThemeSetGroup",
                TITLE : "Centre de services scolaire et commission scolaire francophone et à statut particulier",
                THEMESETS_ELEMENTS : [
                    {
                        ID : "Freq_CS_FRA_ST_1",
                        TYPE : "ThemeSet",
                        TITLE : "Taux annuel de sorties sans diplôme ni qualification au secondaire à la FGJ",
                        SELECTED_DATAVIEW_LAYER : "GEO09E01_CS_FRA_STA_GEN",
                        SELECTED_SEARCH_LAYER : "GEO09E01_CS_FRA_STA_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "GEO09E01_CS_FRA_STA_GEN", ALPHA: 0.75, VISIBLE : true, LABEL_VISIBLE : false},
                                {LAYER_ID : "GEO09E02_CS_ANG_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E04_MUNCP_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E05_MRC_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E06_REG_ADM_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E17_ARRND", VISIBLE : false},
                            ]
                        },
                        THEMES:[
                            {
                                TYPE: "BarChartOverlayTheme",
                                LAYER_ID : "GEO09E01_CS_FRA_STA_GEN",
                                DATATABLE_ID : "t_GEO09E01_CS_FRA_STA_GEN_frequentation",
                                DATACOLUMNS_IDS: ["TX_M_{{VALUE}}", "TX_F_{{VALUE}}"],
                                AS_OVERLAY : false,
                                ENABLED : true,
                                DEFAULT_SIZE: 24,
                                IS_GRADUATED: false,
                                LEGEND_TEXT: "Taux par sexe, cohorte de {{TEXT}}",
                                REPRESENTATION_ENUM: "color",
                                SCHEME: {
                                    ID : "FRA_TX_FM",
                                    SCHEME_ELEMENTS : [
                                        {
                                            REPRESENTATION: "rgba(9,87,151,1)",
                                            VALUE: "Taux annuel de sorties sans diplôme ni qualification (décrochage annuel) au secondaire à la FGJ, sexe masculin, {{TEXT}}",
                                            LEGEND_TEXT: "Sexe masculin"
                                        }, {
                                            REPRESENTATION: "rgba(104,206,186,1)",
                                            VALUE: "Taux annuel de sorties sans diplôme ni qualification (décrochage annuel) au secondaire à la FGJ, sexe féminin, {{TEXT}}",
                                            LEGEND_TEXT: "Sexe féminin"
                                        }
                                    ]
                                },
                            }, {
                                TYPE : "ThemeByRangesOfValues",
                                LAYER_ID : "GEO09E01_CS_FRA_STA_GEN",
                                DATATABLE_ID : "t_GEO09E01_CS_FRA_STA_GEN_frequentation",
                                DATACOLUMN_ID : "TX_T_{{VALUE}}",
                                REPRESENTATION_ENUM : "color",
                                AS_OVERLAY : false,
                                ENABLED : true,
                                LEGEND_TEXT : "Taux annuel de sorties sans diplôme ni qualification au secondaire à la FGJ, sexes réunis, {{TEXT}} (%)",
                                NUMBER_OF_RANGES : 6,
                                SCHEME : {
                                    ID : "FRA_TX_T",
                                    SCHEME_ELEMENTS : [
                                        {
                                            MIN_VALUE : 0,
                                            MAX_VALUE : 10,
                                            REPRESENTATION : "rgba(251, 242, 196, 1)",
                                            LEGEND_TEXT : "moins de 10%"
                                        }, {
                                            MIN_VALUE : 10,
                                            MAX_VALUE : 12,
                                            REPRESENTATION : "rgba(229, 193, 133, 1)",
                                            LEGEND_TEXT : "10% à 12%"
                                        }, {
                                            MIN_VALUE : 12,
                                            MAX_VALUE : 16,
                                            REPRESENTATION : "rgba(224, 162, 120, 1)",
                                            LEGEND_TEXT : "12% à 16%"
                                        }, {
                                            MIN_VALUE : 16,
                                            MAX_VALUE : 18,
                                            REPRESENTATION : "rgba(219, 131, 107, 1)",
                                            LEGEND_TEXT : "16% à 18%"
                                        }, {
                                            MIN_VALUE : 18,
                                            MAX_VALUE : 100,
                                            REPRESENTATION : "rgba(199, 82, 42, 1)",
                                            LEGEND_TEXT : "18% et plus"
                                        }]
                                },
                            }
                        ],
                    }
                ]
            }, {
                ID : "FREQUENTATION_ANG_STA",
                TYPE : "ThemeSetGroup",
                TITLE : "Centre de services scolaire et commission scolaire anglophone et à statut particulier",
                THEMESETS_ELEMENTS : [
                    {
                        ID : "Freq_CS_ANG_ST_1",
                        TYPE : "ThemeSet",
                        TITLE : "Taux annuel de sorties sans diplôme ni qualification au secondaire à la FGJ",
                        SELECTED_DATAVIEW_LAYER : "GEO09E02_CS_ANG_STA_GEN",
                        SELECTED_SEARCH_LAYER : "GEO09E02_CS_ANG_STA_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "GEO09E02_CS_ANG_STA_GEN", ALPHA: 0.75, VISIBLE : true, LABEL_VISIBLE : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E04_MUNCP_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E05_MRC_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E06_REG_ADM_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E17_ARRND", VISIBLE : false},
                            ]
                        },
                        THEMES: [
                            {
                                TYPE: "BarChartOverlayTheme",
                                LAYER_ID : "GEO09E02_CS_ANG_STA_GEN",
                                DATATABLE_ID : "t_GEO09E02_CS_ANG_STA_GEN_frequentation",
                                DATACOLUMNS_IDS: ["TX_M_{{VALUE}}", "TX_F_{{VALUE}}"],
                                AS_OVERLAY : false,
                                ENABLED : true,
                                DEFAULT_SIZE: 24,
                                IS_GRADUATED: false,
                                LEGEND_TEXT: "Taux par sexe, cohorte de {{TEXT}}",
                                REPRESENTATION_ENUM: "color",
                                SCHEME: {
                                    ID : "ANG_TX_FM",
                                    SCHEME_ELEMENTS : [
                                        {
                                            REPRESENTATION: "rgba(9,87,151,1)",
                                            VALUE: "Taux annuel de sorties sans diplôme ni qualification (décrochage annuel) au secondaire à la FGJ, sexe masculin, {{TEXT}}",
                                            LEGEND_TEXT: "Sexe masculin"
                                        }, {
                                            REPRESENTATION: "rgba(104,206,186,1)",
                                            VALUE: "Taux annuel de sorties sans diplôme ni qualification (décrochage annuel) au secondaire à la FGJ, sexe féminin, {{TEXT}}",
                                            LEGEND_TEXT: "Sexe féminin"
                                        }
                                    ]
                                },
                            }, {
                                TYPE : "ThemeByRangesOfValues",
                                LAYER_ID : "GEO09E02_CS_ANG_STA_GEN",
                                DATATABLE_ID : "t_GEO09E02_CS_ANG_STA_GEN_frequentation",
                                DATACOLUMN_ID : "TX_T_{{VALUE}}",
                                REPRESENTATION_ENUM : "color",
                                AS_OVERLAY : false,
                                ENABLED : true,
                                LEGEND_TEXT : "Taux annuel de sorties sans diplôme ni qualification au secondaire à la FGJ, sexes réunis, {{TEXT}} (%)",
                                NUMBER_OF_RANGES : 6,
                                SCHEME : {
                                    ID : "ANG_TX_T",
                                        SCHEME_ELEMENTS : [
                                        {
                                            MIN_VALUE : 0,
                                            MAX_VALUE : 10,
                                            REPRESENTATION : "rgba(251, 242, 196, 1)",
                                            LEGEND_TEXT : "moins de 10%"
                                        }, {
                                            MIN_VALUE : 10,
                                            MAX_VALUE : 12,
                                            REPRESENTATION : "rgba(229, 193, 133, 1)",
                                            LEGEND_TEXT : "10% à 12%"
                                        }, {
                                            MIN_VALUE : 12,
                                            MAX_VALUE : 16,
                                            REPRESENTATION : "rgba(224, 162, 120, 1)",
                                            LEGEND_TEXT : "12% à 16%"
                                        }, {
                                            MIN_VALUE : 16,
                                            MAX_VALUE : 18,
                                            REPRESENTATION : "rgba(219, 131, 107, 1)",
                                            LEGEND_TEXT : "16% à 18%"
                                        }, {
                                            MIN_VALUE : 18,
                                            MAX_VALUE : 100,
                                            REPRESENTATION : "rgba(199, 82, 42, 1)",
                                            LEGEND_TEXT : "18% et plus"
                                        }]
                                },
                            }, 
                        ]
                    }
                ]
            }, {
                ID : "FREQUENTATION_RA",
                TYPE : "ThemeSetGroup",
                TITLE : "Régions administratives",
                THEMESETS_ELEMENTS : [
                    {
                        ID : "Freq_REG_ADM_1",
                        TYPE : "ThemeSet",
                        TITLE : "Taux annuel de sorties sans diplôme ni qualification au secondaire à la FGJ",
                        SELECTED_DATAVIEW_LAYER : "GEO09E06_REG_ADM_GEN",
                        SELECTED_SEARCH_LAYER : "GEO09E06_REG_ADM_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "GEO09E06_REG_ADM_GEN", ALPHA: 0.75, VISIBLE : true, LABEL_VISIBLE : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E02_CS_ANG_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E04_MUNCP_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E05_MRC_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E17_ARRND", VISIBLE : false},
                            ]
                        },
                        THEMES: [
                            {
                                TYPE: "BarChartOverlayTheme",
                                LAYER_ID : "GEO09E06_REG_ADM_GEN",
                                DATATABLE_ID : "t_GEO09E06_REG_ADM_GEN_frequentation",
                                DATACOLUMNS_IDS: ["TX_M_{{VALUE}}", "TX_F_{{VALUE}}"],
                                AS_OVERLAY : false,
                                ENABLED : true,
                                DEFAULT_SIZE: 24,
                                IS_GRADUATED: false,
                                LEGEND_TEXT: "Taux par sexe, cohorte de {{TEXT}}",
                                REPRESENTATION_ENUM: "color",
                                SCHEME: {
                                    ID : "RA_TX_FM",
                                    SCHEME_ELEMENTS : [
                                        {
                                            REPRESENTATION: "rgba(9,87,151,1)",
                                            VALUE: "Taux annuel de sorties sans diplôme ni qualification (décrochage annuel) au secondaire à la FGJ, sexe masculin, {{TEXT}}",
                                            LEGEND_TEXT: "Sexe masculin"
                                        }, {
                                            REPRESENTATION: "rgba(104,206,186,1)",
                                            VALUE: "Taux annuel de sorties sans diplôme ni qualification (décrochage annuel) au secondaire à la FGJ, sexe féminin, {{TEXT}}",
                                            LEGEND_TEXT: "Sexe féminin"
                                        }
                                    ]
                                },
                            }, {
                                TYPE : "ThemeByRangesOfValues",
                                LAYER_ID : "GEO09E06_REG_ADM_GEN",
                                DATATABLE_ID : "t_GEO09E06_REG_ADM_GEN_frequentation",
                                DATACOLUMN_ID : "TX_T_{{VALUE}}",
                                REPRESENTATION_ENUM : "color",
                                AS_OVERLAY : false,
                                ENABLED : true,
                                LEGEND_TEXT : "Taux annuel de sorties sans diplôme ni qualification au secondaire à la FGJ, sexes réunis, {{TEXT}} (%)",
                                NUMBER_OF_RANGES : 6,
                                SCHEME : {
                                    ID : "RA_TX_T",
                                        SCHEME_ELEMENTS : [
                                        {
                                            MIN_VALUE : 0,
                                            MAX_VALUE : 10,
                                            REPRESENTATION : "rgba(251, 242, 196, 1)",
                                            LEGEND_TEXT : "moins de 10%"
                                        }, {
                                            MIN_VALUE : 10,
                                            MAX_VALUE : 12,
                                            REPRESENTATION : "rgba(229, 193, 133, 1)",
                                            LEGEND_TEXT : "10% à 12%"
                                        }, {
                                            MIN_VALUE : 12,
                                            MAX_VALUE : 16,
                                            REPRESENTATION : "rgba(224, 162, 120, 1)",
                                            LEGEND_TEXT : "12% à 16%"
                                        }, {
                                            MIN_VALUE : 16,
                                            MAX_VALUE : 18,
                                            REPRESENTATION : "rgba(219, 131, 107, 1)",
                                            LEGEND_TEXT : "16% à 18%"
                                        }, {
                                            MIN_VALUE : 18,
                                            MAX_VALUE : 100,
                                            REPRESENTATION : "rgba(199, 82, 42, 1)",
                                            LEGEND_TEXT : "18% et plus"
                                        }]
                                },
                            }, 
                        ]
                    }
                ]
            }
        ]
    };
});
